
import { ACTION_METRIC, addCustomMetric, CONTEXT_KEYS, METRIC_TYPE } from '@white-label-helper/shared-helpers';
import IconEnvelope from '@white-label-icon/icon-envelope';
import IconPrinter from '@white-label-icon/icon-printer';
import IconShare from '@white-label-icon/icon-share';
import { defineComponent } from 'vue';
import CavuButton from '../cavu-button/cavu-button.vue';

export default defineComponent({
  name: 'BTicketShareButton',

  components: {
    CavuButton,
  },

  props: {
    showEmail: {
      type: Boolean,
      default: true,
    },
    shouldAlignLeft: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      menuOpened: false,
    };
  },

  computed: {
    IconShare() {
      return IconShare;
    },

    IconEnvelope() {
      return IconEnvelope;
    },

    IconPrinter() {
      return IconPrinter;
    },
  },

  methods: {
    toggleMenu() {
      addCustomMetric(METRIC_TYPE.TRACKING, ACTION_METRIC.SHARE_BUTTON, {
        menuOpened: !this.menuOpened,
      }, null, CONTEXT_KEYS.B_TICKET_SHARE_BUTTON);
      this.menuOpened = !this.menuOpened;
    },
    closeMenu() {
      this.menuOpened = false;
      addCustomMetric(METRIC_TYPE.TRACKING, ACTION_METRIC.SHARE_BUTTON, {
        menuOpened: false,
      }, null, CONTEXT_KEYS.B_TICKET_SHARE_BUTTON);
    },
  },
});
